export default "__VITE_ASSET__fbb22e48__"